<template>
  <div class="site-list-bd">
    <ul class="site-tables-head">
      <li class="ub-f2">
        <span v-if="!type">{{ $t('Common.com_site_name') }}</span>
        <span v-if="type === 'date'">{{ $t('Common.com_time') }}</span>
      </li>
      <li class="ub-f1">
        <span>&emsp;&ensp;{{ $t('site_list.de_fen') }}</span>
      </li>
      <li class="ub-f1">
        <span>&emsp;{{ $t('site_list.shi_fou_da_biao') }}</span>
      </li>
      <li class="ub-f1">
        <span>{{ $t('Common.com_area_cleaned') }}</span>
      </li>
      <li class="ub-f1">
        <span>{{ $t('Common.com_time_cleaned') }}</span>
      </li>
      <li class="ub-f2">
        <span>{{ $t('site_list.zhqjsj') }}</span>
      </li>
      <li class="ub-f1"></li>
    </ul>
    <div style="height: 1px; background: #f0f0f0"></div>
    <!-- 表格内容 -->
    <ul class="site-tables-body">
      <template v-if="siteList && siteList.length > 0">
        <li class="line tbs-item" v-for="(value, index) in siteList" :key="index">
          <ul class="tbs-rows">
            <li class="tbs-cell ub-f2 ub">
              <div>
                <i v-if="!type" class="box icon icon-mianji" style="color: #ffad00"></i>
              </div>
              <span class="bold" v-if="!type">{{ value.siteName || '-' }}</span>
              <span class="bold" v-if="type === 'date'">{{ value.reportDate }}</span>
            </li>
            <li class="tbs-cell ub-f1 ub ub-xc">
              <div
                v-if="value.goalArea"
                class="score"
                :class="{ fail: (value.cleanScore || 0) < 70, yellow: (value.cleanScore || 0) >= 70 && (value.cleanScore || 0) < 90, success: (value.cleanScore || 0) >= 90 }"
              >
                {{ value.cleanScore || 0 }}
              </div>
              <div v-else>&emsp;&ensp;-</div>
            </li>
            <li class="tbs-cell ub-f1 ub">
              <div class="dit-icon" v-if="value.goalArea">
                <i class="icon icon-xinxi" style="font-size: 8px"></i>
              </div>
              <span v-if="value.goalArea" :class="{ fail: !value.isMeetGoal }">{{ value.isMeetGoal ? $t('site_list.yi_da_biao') : $t('site_list.wei_da_biao') }}</span>
              <div v-else>&emsp;&ensp;-</div>
            </li>
            <li class="tbs-cell ub-f1 ubv ub-ac">
              <div class="ub ub-sp" style="line-height: 20px">
                <span>{{ $formatLenLocal(value.totalCleanArea) || ' -' }} {{ $formatLenUnit() }}</span>
                <span>{{ value.totalCleanArea && value.goalArea ? Number.parseInt((value.totalCleanArea / value.goalArea) * 100) : ' -' }} %</span>
              </div>
              <div class="bar">
                <div :style="{ width: value.totalCleanArea && value.goalArea ? `${(value.totalCleanArea / value.goalArea > 1 ? 1 : value.totalCleanArea / value.goalArea) * 100}%` : 0 }"></div>
              </div>
            </li>
            <li class="tbs-cell ub-f1 ubv ub-ac">
              <div class="ub ub-sp" style="line-height: 20px">
                <span>{{ Number.parseInt((value.totalUsageTime || 0) / 60, 10) | formatHourMinute }} h:m</span>
                <span>{{ value.totalUsageTime && value.goalTime ? Number.parseInt((value.totalUsageTime / (value.goalTime * 60)) * 100) : ' -' }} %</span>
              </div>
              <div class="bar">
                <div
                  :style="{ width: value.totalUsageTime && value.goalTime ? `${(value.totalUsageTime / (value.goalTime * 60) > 1 ? 1 : value.totalUsageTime / (value.goalTime * 60)) * 100}%` : 0 }"
                ></div>
              </div>
            </li>
            <li class="tbs-cell ub-f2">
              <span>{{ momentAmPm($momentLocal(value.lastCleanEndTime)) }}</span>
            </li>
            <li class="tbs-cell ub-f1 ub ub-sp ub-xc">
              <div>
                <template v-if="isSet">
                  <el-button type="text" size="mini" @click="setTarget(value)">{{ $t('site_list.she_zhi_mu_biao_zhi') }}</el-button>
                </template>
              </div>
              <div class="next-icon" @click="showDevice(value)">
                <i class="icon icon-you"></i>
              </div>
            </li>
          </ul>
        </li>
      </template>
      <li class="no-data" v-else>{{ $t('Common.com_no_data') }}</li>
    </ul>
    <target-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSuccess"></target-dialog>
    <device-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></device-dialog>
  </div>
</template>

<script>
import targetDialog from './target_dialog.vue';
import deviceDialog from './device_dialog.vue';

export default {
  name: 'site_list',
  components: { targetDialog, deviceDialog },
  props: {
    isSet: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '', // date
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    selectDate: [String], // 世界时间字符串
  },
  computed: {
    siteList: vm => vm.list,
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  mounted: function () {
    this.getFuncView();
  },
  methods: {
    onSuccess() {
      this.$emit('success');
    },
    // 设置目标值
    setTarget(row) {
      this.dialogModel = {
        title: this.$t('site_list.she_zhi_mu_biao_zhi'),
        row: {
          goalArea: row.goalArea || '',
          goalTime: row.goalTime || '',
          locationId: row.locationId,
          siteId: row.siteId,
          startTime: this.$moment.utc(this.selectDate).format('YYYY-MM-DD HH:mm:ss'),
          endTime: this.$moment.utc(this.selectDate).add(1, 'd').format('YYYY-MM-DD HH:mm:ss'),
        },
      };
      this.dialogVisible = true;
    },
    // 查看设备
    showDevice(row) {
      this.dialogModel1 = {
        selectDate: this.selectDate,
        row,
      };
      this.dialogVisible1 = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.site-list-bd {
  // margin-top: 16px;
  background-color: #ffffff;
  border-radius: 16px;
  // padding: 24px;
  .score {
    height: 40px;
    line-height: 40px;
    width: 60px;
    border-radius: 40px;

    text-align: center;
    font-size: 18px;
    color: #ffffff;
    font-weight: bold;
    &.fail {
      background-color: #eb5a5a;
    }
    &.yellow {
      background-color: #fac04c;
    }
    &.success {
      background-color: #93da49;
    }
  }
  .site-tables-head {
    display: flex;
    background-color: #fff;
    border-radius: 16px;
    li {
      &:first-child {
        padding-left: 0;
        span {
          padding-left: 24px;
        }
      }
      &:last-child {
        padding-right: 0;
      }
      height: 56px;
      line-height: 56px;
      font-size: 14px;
      padding-left: 10px;
      padding-right: 12px;
      font-weight: bold;
      color: $--color-text-secondary;
    }
  }

  .site-tables-body {
    height: 500px;
    overflow-y: auto;
    // 无数据
    .no-data {
      margin-top: 24px;
      height: 130px;
      text-align: center;
      line-height: 130px;
      font-size: 16px;
      color: #818181;
      background: #ffffff;
      border-radius: 16px;
    }
    .tbs-item {
      &:nth-child(2n) .tbs-rows {
        background-color: #f8f9fa;
      }
      .tbs-rows {
        cursor: pointer;
        height: 80px;
        line-height: 80px;
        border-radius: 16px;
        display: flex;
        background-color: #fff;
        .tbs-cell {
          &:first-child {
            padding-left: 0;
            & > div {
              padding-left: 24px;
            }
          }
          &:last-child {
            padding-right: 0;
          }
          padding-left: 10px;
          padding-right: 12px;
          color: $--color-text-secondary;
          i.box {
            color: $--color-primary;
            font-size: 22px;
            margin-right: 8px;
          }
          .dit-icon {
            .icon {
              color: $--color-primary;
              font-size: 8px;
              margin-right: 10px;
            }
          }
          .next-icon {
            padding-right: 24px;
            .icon {
              font-size: 24px;
              color: #7b7f93;
            }
          }
          .el-button span {
            color: $--color-primary;
          }
          span {
            color: $--color-text-regular;
            font-size: 14px;
            &.bold {
              font-weight: bold;
            }
            &.fail {
              color: #eb5a5a;
            }
          }
          .bar {
            height: 5px;
            border-radius: 5px;
            background: #f0f0f0;
            margin-top: 5px;
            div {
              height: 5px;
              border-radius: 5px;
              background: $--color-primary;
            }
          }
        }
      }
    }
  }
}
</style>
